import React, { useContext } from 'react'
import AnnouncementDetail from './Components/Announcement/AnnouncementDetail'
import AnnouncementList from './Components/Announcement/AnnouncementList'
import CustomizerContext from '../../_helper/Customizer'
import { Col, Container, Row } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCertificate } from '@fortawesome/pro-duotone-svg-icons'
import { Typography } from '@mui/material'
import GAList from './Components/GAList/GAList'
import ApplicantsByGA from './Components/ApplicantsByGA/ApplicantsByGA'


const GeneralAvailability = () => {
  const {showGaSummary} = useContext(CustomizerContext)

  return (
    <Container fluid={true}>
      {/* <Row className="bg-primary rounded py-3 mb-3">
        <Col className="d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faCertificate} size="xl" />
          <Typography variant="h6">Announcement-General Availability</Typography>
        </Col>
      </Row> */}
      <GAList />
      {/* <ApplicantsByGA GaId={"GA-GGRF-14-004-14"}/> */}
      {/* <AnnouncementList /> */}
      {/* {showGaSummary && 
      <AnnouncementDetail />
      
    } */}
    </Container>
  )
}

export default GeneralAvailability